import { useState, useEffect } from 'react'
import { Calendar } from '@carbon/icons-react'
import { translations } from '../utils/textosMeetingComponent'
import MessagesModal from './MessagesModal'

interface MeetingDataProps {
  brand: string
  startDate: string
  endDate: string
  language: string
  token: string
}

const MeetingData = ({
  brand,
  startDate,
  endDate,
  language,
  token,
}: MeetingDataProps) => {
  const lang = translations[language as keyof typeof translations]
    ? language
    : 'es'
  const texts = translations[lang as keyof typeof translations]
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [permissionsDenied, setPermissionsDenied] = useState(false)

  useEffect(() => {
    const requestPermissions = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
        setIsModalOpen(false)
      } catch (error) {
        console.error('Permisos denegados:', error)
        setPermissionsDenied(true)
        localStorage.setItem('permissionsDenied', 'true')
        setIsModalOpen(true)
      }
    }

    requestPermissions()
  }, [])

  return (
    <div className="flex flex-col w-auto lg:w-full gap-3 md:gap-8 lg:ml-5 text-[22px] text-generic-neutral-900 font-aeonik ">
      <p className="font-bold text-center text-[22px]">
        {brand === 'vidacaixa' ? texts.titleCaixa : texts.titleQida}
      </p>
      <div className="flex justify-center items-center mb-12 text-[20px] text-generic-neutral-900 font-aeonik">
        <span role="img" aria-label="calendar" className="mr-1.25">
          <Calendar size={24} className="mt-2" />
        </span>
        <span className="font-normal ml-4 text-generic-neutral-900 font-aeonik">
          {texts.scheduled}
        </span>
      </div>
      <div
        className="text-[20px] text-center text-generic-neutral-900 font-aeonik -mt-8"
        dangerouslySetInnerHTML={{ __html: startDate }}
      />
      <MessagesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        brand={brand}
        language={language}
        startDate={startDate}
        endDate={endDate}
        token={token}
        permissionsDenied={permissionsDenied}
      />
    </div>
  )
}

export default MeetingData
